import {DWSwitchTextTypeCommand} from './DWSwitchTextTypeCommand'
import {DWSwitchTextTypeTool} from './DWSwitchTextTypeTool'
import {DWSwitchTextTypeSettings} from './DWSwitchTextTypeSettings'

const SwitchTextTypePackage = {
    name: 'switch-text-type',
    configure: function(configurator) {

        configurator.addCommand('switch-text-type', DWSwitchTextTypeCommand)

        configurator.addTool('switch-text-type', DWSwitchTextTypeTool, {
            toolGroup: 'content-menu'
        })

        configurator.addLabel('Text styles', {
            sv: 'Textstilar'
        })

        configurator.addLabel('Show text styles in writer', {
            sv: 'Visa textstilar vid varje stycke'
        })

        configurator.addPluginModule(
            'se.infomaker.switch-text-type.settings',
            DWSwitchTextTypeSettings,
            'se.infomaker.npwriter.settings'
        )
    }
}

export {SwitchTextTypePackage}
